
import {
    EXPLORARFICHA_LOADING,
    EXPLORARFICHA_LOADED,
    EXPLORARFICHA_ERROR,

    EXPLORARFICHAINDI_LOADING,
    EXPLORARFICHAINDI_LOADED,
    EXPLORARFICHAINDI_ERROR,

    EXPLORARHOME1_LOADING,
    EXPLORARHOME1_LOADED,
    EXPLORARHOME1_ERROR,

    SLIDERS_LOADING,
    SLIDERS_LOADED,
    SLIDERS_ERROR,

  } from './../../types/explorar';

const INITIAL_STATE = {
    isLoading: false,
    isLoading2: false,
    fichas: null,
    fichaindi: null,
    fichashome: null,
    slider:[],
    sliderLoading:false,
    sliderLoaded:false,
    error: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case SLIDERS_LOADING:
            return {
                ... state,
                sliderLoading:true,
                sliderLoaded:false,
                error: ''
            }
        case SLIDERS_LOADED:
            return {
                ...state,
                slider:action.payload,
                sliderLoading:false,
                sliderLoaded:true,
                error: '',
            };
        case SLIDERS_ERROR:
            return {
                ...state,
                slider:[],
                sliderLoading:false,
                sliderLoaded:false,
                error: action.payload,
            }

        case EXPLORARHOME1_LOADING:
            return {
                ... state,
                isLoading : false,
                isLoading2: true,
                fichaindi: null,
                fichashome: null,
                fichas: null,
                error: ''
            }
        case EXPLORARHOME1_LOADED:
            return {
                ...state,
                fichashome: action.payload,
                fichaindi: null,
                fichas: null,
                error: '',
                isLoading: false,
                isLoading2: false,
            };
        case EXPLORARHOME1_ERROR:
            return {
                ...state,
                fichaindi: null,
                fichas: null,
                isLoading: false,
                isLoading2: false,
                fichashome: null,
                error: action.payload,
            }
    
        case EXPLORARFICHAINDI_LOADING:
            return {
                ... state,
                isLoading : false,
                isLoading2: true,
                fichaindi: null,
                fichas: null,
                error: ''
            }
        case EXPLORARFICHAINDI_LOADED:
            return {
                ...state,
                fichaindi: action.payload,
                fichas: null,
                error: '',
                isLoading: false,
                isLoading2: false,
            };
        case EXPLORARFICHAINDI_ERROR:
            return {
                ...state,
                fichaindi: null,
                fichas: null,
                isLoading: false,
                isLoading2: false,
                error: action.payload,
            }

        case EXPLORARFICHA_LOADING:
            return {
                ... state,
                isLoading : true,
                isLoading2: false,
                fichas: null,
                fichaindi: null,
                error: ''
            }
        case EXPLORARFICHA_LOADED:
            return {
                ...state,
                fichas: action.payload,
                fichaindi: null,
                error: '',
                isLoading: false,
                isLoading2: false,
            };
        case EXPLORARFICHA_ERROR:
            return {
                ...state,
                fichas: null,
                fichaindi: null,
                isLoading: false,
                isLoading2: false,
                error: action.payload,
            }
        default: return state;
    }
}